// extracted by mini-css-extract-plugin
module.exports = {"content":"CardMultilineLine_content__V1RjJ","source":"CardMultilineLine_source__YyZzK"};